/** IANA timezone from the browser (e.g. America/New_York). */
export const getBrowserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
};

const localeTimeOptions = (timeZone) => ({
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
  timeZone,
});

const localeDateTimeOptions = (timeZone) => ({
  weekday: 'short',
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
  timeZone,
});

const localeFullDateOptions = (timeZone) => ({
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
  timeZone,
});

// Format timestamp for display in the user's local timezone
export const formatTimestamp = (timestamp, timeZone = getBrowserTimezone()) => {
  const date = new Date(timestamp);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return date.toLocaleTimeString('en-US', localeTimeOptions(timeZone));
  if (diffDays < 7) return date.toLocaleDateString('en-US', localeDateTimeOptions(timeZone));
  return date.toLocaleDateString('en-US', localeFullDateOptions(timeZone));
};

// Generate unique ID
export const generateId = (prefix = 'id') => {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

// Search filter function
export const searchFilter = (items, searchTerm, fields) => {
  if (!searchTerm) return items;
  
  const term = searchTerm.toLowerCase();
  return items.filter(item => 
    fields.some(field => {
      const value = field.split('.').reduce((obj, key) => obj?.[key], item);
      return value?.toString().toLowerCase().includes(term);
    })
  );
};

// Parse @mentions in text
export const parseMentions = (text, agents) => {
  const mentionRegex = /@(\w+[\w-]*)/g;
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = mentionRegex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ type: 'text', content: text.slice(lastIndex, match.index) });
    }
    
    const mentionName = match[1].toLowerCase();
    const mentionedAgent = agents.find(a => a.name.toLowerCase() === mentionName);
    parts.push({
      type: 'mention',
      content: match[0],
      agentId: mentionedAgent?.id
    });
    
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push({ type: 'text', content: text.slice(lastIndex) });
  }

  return parts.length > 0 ? parts : [{ type: 'text', content: text }];
};
